module.exports = __webpack_public_path__ + "img/izi_icon.087e825d.png";